import {ScheduleSlot} from '../../counselor360/scheduling/schedule-student-list/schedule-slot';

export class ScheduleStudentListPreferences {

    // Server Properties
    AvailableSlots: string[] = [];
    ShowSchedulingSlots: string[] = [];
    AvailableMainGridColumns: string[] = [];
    ShowMainGridColumns: string[] = [];
    AvailableSubGridColumns: string[] = [];
    ShowSubGridColumns: string[] = [];
    CheckPeriodOverlaps: boolean;
    CheckDayOverlaps: boolean;
    CheckTermOverlaps: boolean;

    // Local Properties
    get termDisplay(): boolean {
        return this.ShowSchedulingSlots.includes(ScheduleSlot.Displays.Term);
    }

    get periodDisplay(): boolean {
        return this.ShowSchedulingSlots.includes(ScheduleSlot.Displays.Period);
    }

    get dayDisplay(): boolean {
        return this.ShowSchedulingSlots.includes(ScheduleSlot.Displays.Day);
    }
}
